import parse from "html-react-parser";
import { useRouter } from "next/router";
import React, { useCallback, useState } from "react";
import styled from "styled-components";

import { RouteName } from "@/consts";
import { Shade } from "@/features/common/components/shade";
import {
  imageCardOptions as normalPostRichTextOptions,
  articlePostOptions as articlePostRichTextOptions,
} from "@/features/tiptap/helpers/richTextClassesAndParsingOptions";

const TextOverflowDiv = styled.div`
  position: relative;
  overflow: hidden;
  max-height: ${(props) => props.maxHeight}px;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  p:first-child {
    margin-top: 0;
  }
`;

type RichTextContentProps = {
  showAll?: boolean;
  isPreview?: boolean;
  isOwner?: boolean;
  content?: string;
  isLanding?: boolean;
  isImageCard?: boolean;
};

export const RichTextContent: React.FC<RichTextContentProps> = (props) => {
  const { showAll, content, isLanding, isImageCard } = props;
  const [showShade, setShowShade] = useState(false);

  const maxHeight = showAll ? "auto" : 200;
  const shadeColor =
    "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%)";

  const ref = useCallback(
    (ref) => {
      if (!ref) return;
      if (ref.clientHeight > maxHeight) return setShowShade(true);
      setShowShade(false);
    },
    [maxHeight],
  );

  return (
    /* TODO: use visibleHeight for this */
    <TextOverflowDiv maxHeight={maxHeight} data-test-id="Content-container">
      {showShade && <Shade backgroundGradient={shadeColor} />}
      <div
        ref={ref}
        onContextMenu={(e) => e.preventDefault()}
        className="select-none cursor-default"
      >
        {parse(
          content ?? "",
          isImageCard ? normalPostRichTextOptions : articlePostRichTextOptions,
        )}
      </div>
    </TextOverflowDiv>
  );
};
